firebird.controller('recordingOptionsModalCtrl', [
    '$rootScope',
    '$scope',
    'upgradedRecordingService',
    function ($rootScope, $scope, upgradedRecordingService) {
        var self = this;

        self.modalState = 'closed';
        self.append = append;
        self.overwrite = overwrite;

        $scope.$on('show-modal', onShowModal);
        $scope.$on('hide-modal', onHideModal);

        function append() {
            upgradedRecordingService.append();
        }

        function overwrite() {
            upgradedRecordingService.overwrite();
        }

        function onShowModal(e, modalName) {
            if (modalName === 'recordingOptions') {
                self.modalState = 'open';
            }
        }

        function onHideModal(e, modalName) {
            if (modalName.indexOf('recordingOptionsModalCtrl') !== -1) {
                self.modalState = 'closed';

                if (!$scope.$$phase) {
                    $scope.$digest();
                }
            }
        }
    }
]);
